import { useTicketsCart } from './useTicketsCart';

export const useCartVersion = () => {
  const { cart } = useTicketsCart();
  return cart?.version ?? 1;
};
